var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',[_c('template',{slot:"header"},[_c('div',{staticClass:"header-caption"},[_vm._v("Setup")])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }